import * as React from 'react';
import Cart from "@system/config/cart";

const ReturnToCartPopup = (props) => {
    const { SetStatus, data } = props;
    const getTitleText = () => {
        return 'Leaving Page?';
    }

    return (
        <>
            <div className="avnet-modal modal-530">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}


                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>

                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-4 pe-4">
                            {getTitleText()}
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            Click <strong>"Continue"</strong> to leave checkout and return to your Cart.
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                cancel
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                onClick={() => {
                                    window.location.href = Cart.getCartPageRouteURL();
                                }}
                            >
                                CONTINUE
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default ReturnToCartPopup;